import _ from "lodash";
import { InputSelector } from "./InputSelector";
import { IBaseFormProps } from "../interfaces";

/**
 *
 * @param schema loaded schema
 * @param modelName name of model
 * @param itemData itemData state
 * @param setItemData setItemData state
 * @returns
 */
const BaseForm = ({
  schema,
  modelName,
  itemData,
  setItemData,
  customModel,
  onSubmit,
}: IBaseFormProps): JSX.Element => {
  const updateItemData = (keyname: string, value: any) => {
    if (_.has(itemData, keyname))
      setItemData({
        ...itemData,
        [keyname]: value,
      });
  };

  return (
    <form onSubmit={onSubmit} id="base-form">
      <div className="flex flex-col gap-4">
        {schema.map((item, index) => (
          <InputSelector
            value={itemData[item.name]}
            key={index}
            onChange={(e) => {
              updateItemData(
                item.name,
                item.type === "number"
                  ? e.target.valueAsNumber
                  : item.type === "bool"
                  ? e.target.checked
                  : e.target.value
              );
            }}
            modelname={modelName}
            customModel={customModel}
            {...item}
          />
        ))}
      </div>
    </form>
  );
};

export default BaseForm;
